export default __webpack_public_path__ + "static/media/oleksandr_velychko.a56cbb45.png";